if (!customElements.get('author-tabs')) {
  class AuthorTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
    }

    activate(tab) {
      const targetId = tab.getAttribute('aria-controls');

      this.tabs.forEach((current) => {
        const isSelected = current === tab;
        current.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        current.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });
    }

    onKeydown(event) {
      const index = this.tabs.indexOf(document.activeElement);
      if (index < 0) return;

      let nextTab = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextTab = this.tabs[(index + 1) % this.tabs.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextTab = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      } else if (event.key === 'Home') {
        [nextTab] = this.tabs;
      } else if (event.key === 'End') {
        nextTab = this.tabs[this.tabs.length - 1];
      }

      if (nextTab) {
        event.preventDefault();
        nextTab.focus();
        this.activate(nextTab);
      }
    }
  }

  customElements.define('author-tabs', AuthorTabs);
}
